import { division } from 'accurate';
import dayjs from 'dayjs';
import i18next from 'i18next';
import { parse } from 'query-string';
import { getMessage, kkBridgeHasMethod } from './jsBridge';

export const isDDQ = import.meta.env.VITE_APP_NAME === 'doudou';

export const isCCL = import.meta.env.VITE_APP_NAME === 'kaka';

export const isHK = import.meta.env.VITE_APP_NAME === 'CreFIT';

// 将“分”换算成“元”
export const formatMoney = (val: any) => {
  if (isNaN(Number(val))) return val;
  return division(val, 100);
};

export const numFormat = (val: number | string) => {
  const c =
    Number(val).toString().indexOf('.') !== -1
      ? Number(val).toLocaleString()
      : Number(val)
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  return c;
};

export const getKakaRegisterId = () => {
  let registerId: string | Promise<string> = '';
  // 为了开发过程中方便，development时可以获取localStorage中数据
  if (import.meta.env.VITE_APP_ENV === 'development') {
    registerId =
      window.localStorage.getItem('registerId') || getMessage<string>('getRegisterId', {}, false);
  } else {
    registerId = getMessage<string>('getRegisterId', {}, false);
  }
  return registerId;
};

export const getDoudouAccessToken = async () => {
  let accessToken: string;
  // 为了开发过程中方便，development时可以获取localStorage中数据
  if (import.meta.env.VITE_APP_ENV === 'development') {
    accessToken =
      window.localStorage.getItem('accessToken') ||
      (await getMessage<string>('getUserToken', '', false)) ||
      '';
  } else {
    accessToken = (await getMessage<string>('getUserToken', '', false)) || '';
  }
  return accessToken;
};

export const getBankCardLastFourNum = (bankNum: string) => {
  let lastFourNum = '';
  if (bankNum.length > 4) {
    lastFourNum = bankNum.substring(bankNum.length - 4);
  } else {
    lastFourNum = bankNum;
  }
  return lastFourNum;
};

export const updateDocumentTitle = (title: string) => {
  document.title = title;
};

export const isDev = () =>
  import.meta.env.VITE_APP_ENV === 'development' &&
  window.origin !== 'https://dev-vhk.vcredit.com.hk';

export const isCrefitApp = () => !!kkBridgeHasMethod('kk_getNativeLanguage');

export const isEkycWebview = () => {
  const params = parse(location.search);
  return params.env === 'ekyc';
};

export const isEn = () => i18next.language === 'en';

export const handleEnClsName = (clsName: string) => `${clsName} ${isEn() ? 'en' : ''}`;

/**
 * 计算截止时间
 * @param marketingStartTime 营销开始时间
 * @param validTime 有效时间（分钟）
 * @returns 截止时间字符串
 * @author bycursor
 */
export const calculateDeadline = (marketingStartTime: string, validTime: number): string => {
  const startTime = dayjs(marketingStartTime);
  const endTime = startTime.add(validTime, 'second');
  return endTime.format('YYYY-MM-DD HH:mm:ss');
};
